import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';

import intlTelInput from "intl-tel-input";
import 'intl-tel-input/build/js/utils';
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.js";
import "pdfjs-dist/legacy/build/pdf.worker.entry";
// Import F7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons, Fonts and App Custom Styles
import 'intl-tel-input/build/css/intlTelInput.min.css';
import '@material-design-icons/font/index.css';
import '../css/icons.css';
import '../css/fonts.css';
import '../css/app.scss';
import '../css/webapp.scss';
import 'cropperjs/dist/cropper.min.css';

//Require is allowed with in if-else, import is not allowed
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';
// Import Vars
import countryFinder from './plugins/country-finder.js';

import vars from './vars.js';
import templates from './templates.js';
import moment from "moment";
import alertAudio from "../webapp/audio/alert.mp3";

// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getMessaging, getToken, onMessage} from "firebase/messaging";
// https://firebase.google.com/docs/web/setup#available-libraries

const env = process.env.NODE_ENV;
if(env === "production") {
    window.host = window.cordovaHost;
    console.log = () => {
    };
    console.error = () => {
    };
    console.warn = () => {
    };
}

var vrs = vars;
var cntrFndr = countryFinder;
var tmplts = templates;

window.IS_WEBAPP = true;
$$("html").addClass("is-webapp");

var app = new Framework7({
    root: '#app', // App root element
    id: 'com.mitsulift.mitsuapp.client', // App bundle ID
    name: 'Mitsulift', // App name
    theme: 'ios', // Automatic theme detection
    // App root data
    data: function () {
        return {
            country: window.country.toUpperCase(),
            phone: '',
            email: '',
            user: {
                firstName: 'John',
                lastName: 'Doe',
            },
        };
    },
    // App root methods
    iosTranslucentModals: false,
    iosTranslucentBars: true,
    autoDarkTheme: false,
    touch: {
        disableContextMenu: true,
        iosTouchRipple: false,
        activeStateOnMouseMove: false,
    },
    methods: {
        initializeViews: function () {
            app.views.create('.view-main', {url: '/news/', stackPages: true, });
            app.views.create('.view-my-mitsu', {url: '/my-mitsu/', stackPages: true});
            // app.views.create('.view-news', {url: '/news/', stackPages: true});
            // app.views.create('.view-account', {url: '/account/', stackPages: true});
            app.views.create('.view-notifications', {url: '/notifications/', stackPages: true});
        },
        initializeGuestViews: function () {
            //app.views.create('.view-main', {url: '/about/', stackPages: true});
        },
        updateRegid: function (regid) {
            if (regid) {
                app.request({
                    url: Url.to("user/regid"),
                    method: "POST",
                    preloader: false,
                    progress: false,
                    data: {
                        regid: regid,
                        platform: app.device.os
                    },
                    success: function (data, status, xhr) {
                        console.log(data);
                    },
                });
            }
        },
        clearRegid: function (regid) {
            if (regid) {
                app.request({
                    url: Url.to("site/clear-regid"),
                    method: "POST",
                    preloader: false,
                    progress: false,
                    data: {
                        regid: regid,
                        platform: app.device.os
                    },
                    success: function (data, status, xhr) {
                        console.log(data);
                    },
                });
            }
        },
        helloWorld: function () {
            app.dialog.alert('Hello World!');
        },
        gotToAddLocation() {
            if (window.identity['gdpr_consent']) {
                app.views.current.router.navigate("/add-location/");
            } else {
                app.dialog.create({
                    title: "<i class='material-icons text-color-red'>warning</i>",
                    content: "You have withdrawn your GDPR consent from Mitsulift, " +
                        "you are not allowed to add any location to your account unless you give consent again.",
                    verticalButtons: true,
                    buttons: [
                        {
                            text: 'Give Consent',
                            //color: 'red',
                            onClick() {
                                app.views.current.router.navigate("/manage-consent/");
                            }
                        },
                        {
                            text: 'Cancel',
                            color: 'red',
                            onClick() {
                            }
                        },
                    ]
                }).open();
            }
        },
        previewPdfDocument(url, on) {
            // window.open(url, "_blank")
            // return;
            app.dialog.preloader();
            setTimeout(() => {
                app.methods.loadPdfDocument(url, (pages) => {
                    //console.log(pages);
                    app.dialog.close();
                    var documentViewer = app.photoBrowser.create({
                        photos: pages,
                        theme: 'dark',
                        type: 'standalone',
                        on: on
                    });
                    documentViewer.open();
                });
            }, 200)
        },
        loadPdfDocument(url, callback) {
            pdfjsLib.GlobalWorkerOptions.workerSrc = window.pdfjsWorker;
            const loadingTask = pdfjsLib.getDocument(url);
            let pages = [];
            let pagesCompleted = 0;
            loadingTask.promise
                .then(function (pdfDocument) {
                    console.log(pdfDocument.numPages);
                    for (let page = 1; page <= pdfDocument.numPages; page++) {
                        const canvas = document.createElement('canvas');
                        pdfDocument.getPage(page).then(function (pdfPage) {
                            const viewport = pdfPage.getViewport({scale: 1.5});//document.getElementById("theCanvas");
                            canvas.width = viewport.width;
                            canvas.height = viewport.height;
                            const ctx = canvas.getContext("2d");
                            const renderTask = pdfPage.render({
                                canvasContext: ctx,
                                viewport,
                            });
                            return renderTask.promise;
                        }).then(function () {
                            pages.push(canvas.toDataURL());
                            pagesCompleted++;
                            if (pagesCompleted === pdfDocument.numPages) {
                                callback(pages);
                            }
                        });

                    }
                })
                .catch(function (reason) {
                    console.error("Error: " + reason);
                });

        },
        pingServer: function () {
            if (!window.device) {
                window.device = {
                    available: true,
                    cordova: "10.1.2",
                    isVirtual: true,
                    manufacturer: "Google",
                    model: "sdk_gphone_x86",
                    platform: "Android",
                    serial: "unknown",
                    uuid: "2009f90ed2b42711",
                    version: "11",
                };
            }
            app.request({
                url: Url.to("user/ping"),
                preloader: false,
                progress: false,
                method: "POST",
                data: {
                    details: JSON.stringify(window.device),
                    app_version: window.appVersionLabel,
                    app_build_number: window.buildNumber,
                    app_platform: window.device.platform,
                    app_platform_version: window.device.version,
                    // available: true,
                    // cordova: "10.1.2",
                    // isVirtual: true,
                    // manufacturer: "Google",
                    // model: "sdk_gphone_x86",
                    // platform: "Android",
                    // serial: "unknown",
                    // uuid: "2009f90ed2b42711",
                    // version: "11",
                },
                success: function (data, status, xhr) {
                    setTimeout(function () {
                        app.methods.pingServer();
                    }, 30000);
                },
            });

        },
    },
    // App routes
    routes: routes,

    // Input settings
    input: {
        scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
        scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
    },
    // Cordova Statusbar settings
    statusbar: {
        iosOverlaysWebView: true,
        androidOverlaysWebView: false,
    },
    on: {
        init: function () {
            var f7 = this;
            if (f7.device.cordova) {
                // Init cordova APIs (see cordova-app.js)
                cordovaApp.init(f7);
            } else {
                cordovaApp.f7 = f7;
                cordovaApp.handleAndroidBackButton();
            }
            var iconTooltip = f7.tooltip.create({
                targetEl: '.location-code-tooltip',
                text: 'Scan the invitation Qr code you received from Mitsulift',
            });
        },
    },
});
window.deeplinkCode = null;

function setCordovaEnv() {
    if (window.cordova) {
        if (window.cordova.getAppVersion) {
            window.cordova.getAppVersion.getVersionNumber(function (versionNumber) {
                window.appVersionLabel = versionNumber;
            });
        }
        if (window.cordova.plugins) {
            if (window.cordova.plugins.firebase) {
                cordova.plugins.firebase.dynamiclinks.onDynamicLink(function (data) {
                    console.log("Dynamic link click with data:", data);
                    if (data) {
                        console.log("Read dynamic link data on app start:", data);
                        if (data['deepLink']) {
                            console.log("Deep Link:", data['deepLink']);
                            var url = new URL(data['deepLink']);
                            window.deeplinkCode = url.searchParams.get("join");
                            if (!window.loggedIn) {
                                app.loginScreen.open("#signup-screen", true);
                            }
                        }
                    }
                });
                cordova.plugins.firebase.dynamiclinks.getDynamicLink().then(function (data) {
                    if (!window.deeplinkCode && data) {
                        console.log("Read dynamic link data on app start:", data);
                        if (data['deepLink']) {
                            console.log("Deep Link:", data['deepLink']);
                            var url = new URL(data['deepLink']);
                            window.deeplinkCode = url.searchParams.get("join");
                            if (!window.loggedIn) {
                                app.loginScreen.open("#signup-screen", true);
                            }
                        }
                    } else {
                        console.log("App wasn't started from a dynamic link");
                    }
                });
            }
        }
    }
    if (window.StatusBar) {
        //StatusBar.styleLightContent();
        StatusBar.styleDefault();
        StatusBar.backgroundColorByHexString("#f9f9f9");

    }
    if (window.PushNotification) {
        const push = window.PushNotification.init({
            android: {
                forceShow: 'true',
                icon: 'notification',
                iconColor: '#378cff'
            },
            ios: {
                alert: "true",
                badge: "false",
                sound: "true"
            }
        });

        push.on('registration', (data) => {
            // data.registrationId
            console.log(data);
            window.registrationId = data.registrationId;
            if (window.loggedIn) {
                app.methods.updateRegid(data.registrationId);
            } else {
                app.methods.clearRegid(data.registrationId);
            }
        });

        push.on('notification', (data) => {
            // data.message,
            // data.title,
            // data.count,
            // data.sound,
            // data.image,
            // data.additionalData
            console.log(data);
            //app.dialog.alert(JSON.stringify(data));
            if (Framework7.device.ios) {
                var notification = app.notification.create({
                    title: data.title,
                    text: data.message,
                    on: {
                        click: function () {
                            //console.log('Notification opened')
                            app.tab.show(".view-notifications", ".tab-link[href='#view-notifications']", false);
                            notification.close();
                        }
                    }
                });
                notification.open();
            } else {
                app.tab.show(".view-notifications", ".tab-link[href='#view-notifications']", false);
            }
        });

        push.on('error', (e) => {
            // e.message
            console.log(e);
        });
    }
    window.device_id = window.registrationId;
    if (!window.device_id) {
        window.device_id = window.device ? window.device.uuid : null;
        if (!window.device_id) {
            window.device_id = localStorage.getItem("device_id");
            if (!window.device_id) {
                window.device_id = "DID" + Math.floor(Math.random() * 100000);
            }
        }
    }
    localStorage.setItem("device_id", window.device_id);
}

window._app = app;
if (Framework7.device.cordova) {
    window.host = window.cordovaHost;//"https://api.mitsulift.codendot.co";
    document.addEventListener('deviceready', setCordovaEnv, false);
} else {
    setCordovaEnv();

    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseConfig = {
        apiKey: "AIzaSyCl7d9tNOZCR2IVpUb88Va8T1Y1JolgPwk",
        authDomain: "mitsulift-codendot.firebaseapp.com",
        databaseURL: "https://mitsulift-codendot.firebaseio.com",
        projectId: "mitsulift-codendot",
        storageBucket: "mitsulift-codendot.appspot.com",
        messagingSenderId: "287319191684",
        appId: "1:287319191684:web:3ab9b30913cca19a8cd2d1",
        measurementId: "G-3W7VZWCKRS"
    };

    // Initialize Firebase
    const firebaseapp = initializeApp(firebaseConfig);
    const analytics = getAnalytics(firebaseapp);
    // Initialize Firebase Cloud Messaging and get a reference to the service
    const messaging = getMessaging(firebaseapp);
    getToken(messaging, {vapidKey: "BD4TZ2gXE3Hvv4QEOpc4qEmoPHzzzGygPgeJTEO4U8N21UVUar-P5Z_14QiHljJM-nab5ezQ12SG-_bVcZi4j9Y"}).then((token) => {
        console.log(">>>>>>>", token);
        window.registrationId = token;
        if (window.loggedIn) {
            app.methods.updateRegid(token);
        } else {
            app.methods.clearRegid(token);
        }
    });
    onMessage(messaging, (payload) => {
        console.log('Message received. ', payload);
        var notification = app.notification.create({
            title: payload['notification']['title'],
            text: payload['notification']['body'],
            on: {
                click: function () {
                    //console.log('Notification opened')
                    app.tab.show(".view-notifications", ".tab-link[href='#view-notifications']", false);
                    notification.close();
                }
            }
        });
        notification.open();
        playSound(alertAudio);
    });
    //window.deeplinkCode = "r5cMIkggvk";
}
window.setupRequest = function () {
    Framework7.request.setup({
        headers: {
            "x-api-key": window.loggedIn ? window.identity['access_token'] : null,
            "x-api-country": window.country
        },
        dataType: "json",
        preloader: true,
        progress: false,
        autoHandleError: true,
        beforeSend: function (xhr) {
            //console.log(xhr);
            if (xhr.requestParameters.preloader) {
                app.dialog.preloader("Please wait");
            }
            if (xhr.requestParameters.progress) {
                app.progressbar.show();
            }
        },
        complete: function (xhr, status) {
            //console.log(xhr, status);
            if (xhr.requestParameters.preloader) {
                app.dialog.close();
            }
            if (xhr.requestParameters.progress) {
                app.progressbar.hide();
            }
        },
        error: function (xhr, status) {
            console.log("xhr.requestParameters.autoHandleError", xhr.requestParameters.autoHandleError);
            if (xhr.requestParameters.autoHandleError) {
                var errors = JSON.parse(xhr.response)['message'];
                //console.log(xhr, status);
                app.dialog.alert(errors, function () {

                });
            }
        },
        statusCode: {
            401: function (xhr) {
                if (window.navigator && window.navigator.splashscreen) {
                    window.navigator.splashscreen.show();
                }
                setTimeout(function () {
                    User.logOut();
                    window.location.reload();
                }, 250);
            }
        }
    })
}
setupRequest();
//console.log(app);
//Initialize Views after login
if (window.loggedIn) {
    app.methods.initializeViews();
    setTimeout(function () {
        app.methods.pingServer();
    }, 5000);
} else {
    app.methods.initializeGuestViews();
    app.loginScreen.open("#my-login-screen", false);
    // app.loginScreen.open("#signup-screen", false);
}

const playSound = (url) => {
    const audio = new Audio(url);
    audio.play();
}
//Login Button
$$('#my-login-screen .login-button').on('click', function () {
    var email = $$('#my-login-screen [name="email"]').val();
    var password = $$('#my-login-screen [name="password"]').val();
    app.request({
        url: Url.to("auth/login"),
        method: "POST",
        data: {
            email: email,
            password: password
        },
        success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            if (Object.keys(data['countries']).length > 1) {
                var buttons = [];
                var fullHtml = '';
                Object.keys(data['countries']).forEach((country_code) => {
                    var listHtml = `<div class="list no-hairlines no-margin-vertical"><ul style="background: transparent">`;
                    listHtml += `
                    <li>
                        <a href="#" class="item-link item-content select-country-" data-country="${country_code}" data-name="${data['countries'][country_code]}">
                            <div class="item-media"><i class="iti__flag iti__${country_code}"></i></div>
                            <div class="item-inner">
                                <div class="item-title text-color-black" style="line-height: normal;">${data['countries'][country_code]}</div>
                            </div>
                        </a>
                    </li>`;
                    listHtml += `</ul></div>`;
                    fullHtml += listHtml;
                    buttons.push({
                        text: listHtml,
                        onClick() {
                            loginToCountry(country_code, data);
                        }
                    });
                });
                app.dialog.create({
                    title: "Mitsulift",
                    text: 'To which country you would like to proceed?',
                    //content: fullHtml,
                    verticalButtons: true,
                    buttons: buttons,
                    on: {}
                }).open();
            } else {
                loginToCountry(data['country'], data);
                // selectCountry(data['country']);
                // app.loginScreen.close('#my-login-screen');
                // User.logIn(data);
                // app.methods.initializeViews();
                // window.setupRequest();
                // app.methods.updateRegid(window.registrationId);
                // app.methods.pingServer();
            }
        },
    });
});
//Forgot password
$$('#forgot-password-screen .forgot-password').on('click', function () {
    var email = $$('#forgot-password-screen [name="email"]').val();
    app.request({
        url: Url.to("auth/forgot-password"),
        method: "POST",
        data: {
            email: email
        },
        success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            app.loginScreen.open("#forgot-password-code-screen", true);
            //app.loginScreen.close('#forgot-password-screen');
            //app.dialog.alert(data['alerts']);
        },
    });
});
//Forgot password code
$$('#forgot-password-code-screen .forgot-password-code').on('click', function () {
    var email = $$('#forgot-password-screen [name="email"]').val();
    var verification_code = $$('#forgot-password-code-screen [name="verification_code"]').val();
    app.request({
        url: Url.to("auth/verify-password-code"),
        method: "POST",
        data: {
            email: email,
            token: verification_code,
        },
        success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            app.loginScreen.open("#reset-password-screen", true);
        },
    });
});
//reset password
$$('#reset-password-screen .reset-password').on('click', function () {
    var email = $$('#forgot-password-screen [name="email"]').val();
    var verification_code = $$('#forgot-password-code-screen [name="verification_code"]').val();
    var new_password = $$('#reset-password-screen [name="new_password"]').val();
    var repeat_password = $$('#reset-password-screen [name="new_password"]').val();
    app.request({
        url: Url.to("auth/reset-password"),
        method: "POST",
        data: {
            email: email,
            token: verification_code,
            password: new_password,
            password_repeat: repeat_password,
        },
        success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            app.loginScreen.close("#reset-password-screen", true);
            app.loginScreen.close("#forgot-password-code-screen", true);
            app.loginScreen.close("#forgot-password-screen", true);
            app.dialog.alert(data['alerts']);
            $$('#my-login-screen [name="email"]').val(email).trigger("change");
        },
    });
});
//Sign Up
window.signupImage = null;
$$('#signup-screen .signup-change-picture').on('click', function () {
    navigator.camera.getPicture(function (imageURI) {
        window.signupImage = "data:image/jpeg;base64," + imageURI;
        $$("#signup-screen .signup-change-picture").css("background-image", 'url("' + window.signupImage + '")');
    }, function (message) {
        //console.log(message);
    }, {
        allowEdit: true,
        quality: 50,
        destinationType: Camera.DestinationType.DATA_URL,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        correctOrientation: true,
        targetWidth: 250,
        targetHeight: 250,
        sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM
    });
});
$$('#signup-screen .sign-up').on('click', function () {
    var signupData = app.form.convertToData("#signup-screen");
    var iti = window.intlTelInputGlobals.getInstance(document.getElementById("register-phone-number"));
    if (iti.isValidNumber()) {
        signupData['phone'] = iti.getNumber();
    } else {
        app.dialog.alert('Please enter a valid phone number');
        return;
    }
    signupData['device_id'] = window.device_id;

    app.request({
        url: Url.to("auth/validate-register"),
        method: "POST",
        data: signupData,
        success: function (data, status, xhr) {
            app.request({
                url: Url.to("data/terms-and-conditions"),
                method: "GET",
                preloader: true,
                progress: false,
                data: {},
                success: function (data, status, xhr) {
                    console.log(data);
                    $$("#tnc-block").html(data['terms']);
                    app.loginScreen.open("#signup-screen-tnc", true);
                },
            });
        },
    });

});
$$('#signup-screen-tnc .submit-sign-up').on('click', function () {
    var acceptTnc = $$("#signup-accept-tnc").is(":checked");
    var enable_notification = $$("#signup-enable-notification").is(":checked");
    if (!acceptTnc) {
        return;
    }
    var signupData = app.form.convertToData("#signup-screen");
    var iti = window.intlTelInputGlobals.getInstance(document.getElementById("register-phone-number"));
    if (iti.isValidNumber()) {
        signupData['phone'] = iti.getNumber();
    } else {
        app.dialog.alert('Please enter a valid phone number');
        return;
    }
    signupData['device_id'] = window.device_id;
    signupData['enable_notification'] = enable_notification;

    //show verification code modal
    app.dialog.create({
        title: "Mitsulift",
        content: 'Is <strong>' + signupData['email'] + '</strong> your actual email? A verification code will be sent to you by email to proceed.',
        verticalButtons: false,
        buttons: [
            {
                text: 'Cancel',
                color: 'red',
                onClick() {
                }
            },
            {
                text: 'Yes',
                onClick(dialog) {
                    app.request({
                        url: Url.to("auth/request-email-verification-code"),
                        method: "POST",
                        data: signupData,
                        success: function (data, status, xhr) {
                            showEmailVerificationCodeModal(signupData, data['allowed_resend_time'], (signupData, code) => {

                            });
                        },
                    });
                }
            },
        ],
    }).open();
    return;


    // app.dialog.create({
    //     title: "Mitsulift",
    //     content: 'Is <strong>' + signupData['phone'] + '</strong> your actual phone number? A verification code will be sent to you by SMS to proceed.',
    //     verticalButtons: false,
    //     buttons: [
    //         {
    //             text: 'Cancel',
    //             color: 'red',
    //             onClick() {
    //             }
    //         },
    //         {
    //             text: 'Yes',
    //             onClick(dialog) {
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    app.request({
        url: Url.to("auth/register"),
        method: "POST",
        data: signupData,
        autoHandleError: true,
        success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            app.loginScreen.close('#signup-screen');
            app.loginScreen.close('#my-login-screen');
            User.logIn(data);
            app.methods.initializeViews();
            window.setupRequest();
            app.methods.updateRegid(window.registrationId);
            app.methods.pingServer();
            if (window.signupImage) {
                setTimeout(function () {
                    app.request({
                        url: Url.to("user/profile-picture"),
                        method: "POST",
                        data: {image: window.signupImage},
                        success: function (data, status, xhr) {
                            User.logIn(data);
                        },
                    });
                }, 1000);
            }
        },
    });
    //ACTIVATE THIS TO REACTIVATE PHONE NUMBER VERIFICATION
    //                 app.request({
    //                     url: Url.to("auth/request-verification-code"),
    //                     method: "POST",
    //                     data: signupData,
    //                     success: function (data, status, xhr) {
    //                         showVerificationCodeModal(signupData, data['allowed_resend_time'], (signupData, code)=>{
    //
    //                         });
    //                     },
    //                 });
    //ACTIVATE THIS TO REACTIVATE PHONE NUMBER VERIFICATION
    // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //             }
    //         },
    //     ],
    // }).open();
    //
});

function submitSignup(signupData, code, time) {
    signupData['verification_code'] = code;
    app.request({
        url: Url.to("auth/register"),
        method: "POST",
        data: signupData,
        autoHandleError: false,
        success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            app.loginScreen.close('#signup-screen');
            app.loginScreen.close('#signup-screen-tnc');
            // app.loginScreen.close('#my-login-screen');
            // app.methods.updateRegid(window.registrationId);
            if (window.signupImage) {
                User.logIn(data);
                //app.methods.initializeViews();
                window.setupRequest();
                setTimeout(function () {
                    app.request({
                        url: Url.to("user/profile-picture"),
                        method: "POST",
                        data: {image: window.signupImage},
                        success: function (data, status, xhr) {
                            User.logOut();
                            window.setupRequest();
                        },
                    });
                }, 1000);
            }
            if (data['status'] == 20) {
                app.dialog.alert("Your account was created successfully.");
                $$("#login-email-input").val(data['email']).trigger("change");
                $$("#login-email-password").val(signupData['password']).trigger("change");
            } else {
                app.dialog.alert("Your account was created successfully, you will be able to login once Mitsulift team verify your account");
            }
        },
        error: function (xhr, status) {
            console.error(xhr)
            var error = JSON.parse(xhr.response);
            console.log(error);
            if (error.code == 4001) {
                app.notification.create({
                    title: error['message'],
                }).open();
                showEmailVerificationCodeModal(signupData, time);
            }
            return false;
        },
    });

}

function showVerificationCodeModal(signupData, time, callbackClick) {
    app.dialog.create({
        title: "Mitsulift",
        text: 'Please enter verification code sent to your phone number by SMS',
        content: window.compiledVerifyPhoneDialogTemplate(),
        verticalButtons: true,
        buttons: [
            {
                text: 'Verify',
                onClick(dialog) {
                    var code = $$("#verification-code").val();
                    submitSignup(signupData, code, time);
                    //callbackClick(signupData, code);
                }
            },
            {
                text: 'Resend Code',
                color: 'countdown disabled',
                onClick() {
                    //call resend code then reshow modal
                    app.request({
                        url: Url.to("auth/request-verification-code"),
                        method: "POST",
                        data: signupData,
                        success: function (data, status, xhr) {
                            showVerificationCodeModal(signupData, data['allowed_resend_time'], callbackClick);
                        }
                    });
                }
            },
            {
                text: 'Cancel',
                color: 'red',
                onClick() {
                }
            },
        ],
        on: {
            open: function (dialog) {
                var duration = moment.duration(time * 1000, 'milliseconds');
                if (duration._milliseconds <= 0) {
                    $$('.color-countdown').removeClass("disabled").text("Resend Code");
                    return;
                }
                $$('.color-countdown').text(
                    (duration.hours() > 0 ? duration.hours() + ":" : "") +
                    ("0" + duration.minutes()).substr(-2) + ":" +
                    ("0" + duration.seconds()).substr(-2)
                )
                var interval = 1000;
                clearInterval(window.countDownInterval);
                window.countDownInterval = setInterval(function () {
                    duration = moment.duration(duration - interval, 'milliseconds');
                    //console.log(duration);
                    //console.log(duration.hours() + ":" + duration.minutes() + ":" + duration.seconds());
                    if (duration._milliseconds <= 0) {
                        $$('.color-countdown').removeClass("disabled").text("Resend Code");
                        clearInterval(window.countDownInterval);
                        return;
                    }
                    $$('.color-countdown').text(
                        (duration.hours() > 0 ? duration.hours() + ":" : "") +
                        ("0" + duration.minutes()).substr(-2) + ":" +
                        ("0" + duration.seconds()).substr(-2)
                    )
                }, interval);
            },
            close: function (dialog) {
                clearInterval(window.countDownInterval);
            }
        }
    }).open();
}

function showEmailVerificationCodeModal(signupData, time, callbackClick) {
    console.log("showEmailVerificationCodeModal", time);
    app.dialog.create({
        title: "Mitsulift",
        text: 'Please enter verification code sent to your email',
        content: window.compiledVerifyPhoneDialogTemplate(),
        verticalButtons: true,
        buttons: [
            {
                text: 'Verify',
                onClick(dialog) {
                    var code = $$("#verification-code").val();
                    submitSignup(signupData, code, time);
                    //callbackClick(signupData, code);
                }
            },
            {
                text: 'Resend Code',
                color: 'countdown disabled',
                onClick() {
                    //call resend code then reshow modal
                    app.request({
                        url: Url.to("auth/request-email-verification-code"),
                        method: "POST",
                        data: signupData,
                        success: function (data, status, xhr) {
                            showEmailVerificationCodeModal(signupData, data['allowed_resend_time'], callbackClick);
                        }
                    });
                }
            },
            {
                text: 'Cancel',
                color: 'red',
                onClick() {
                }
            },
        ],
        on: {
            open: function (dialog) {
                var duration = moment.duration(time * 1000, 'milliseconds');
                if (duration._milliseconds <= 0) {
                    $$('.color-countdown').removeClass("disabled").text("Resend Code");
                    return;
                }
                $$('.color-countdown').text(
                    (duration.hours() > 0 ? duration.hours() + ":" : "") +
                    ("0" + duration.minutes()).substr(-2) + ":" +
                    ("0" + duration.seconds()).substr(-2)
                )
                var interval = 1000;
                clearInterval(window.countDownInterval);
                window.countDownInterval = setInterval(function () {
                    duration = moment.duration(duration - interval, 'milliseconds');
                    //console.log(duration);
                    //console.log(duration.hours() + ":" + duration.minutes() + ":" + duration.seconds());
                    if (duration._milliseconds <= 0) {
                        $$('.color-countdown').removeClass("disabled").text("Resend Code");
                        clearInterval(window.countDownInterval);
                        return;
                    }
                    $$('.color-countdown').text(
                        (duration.hours() > 0 ? duration.hours() + ":" : "") +
                        ("0" + duration.minutes()).substr(-2) + ":" +
                        ("0" + duration.seconds()).substr(-2)
                    )
                }, interval);
            },
            close: function (dialog) {
                clearInterval(window.countDownInterval);
            }
        }
    }).open();
}

if (!Framework7.device.ios) {
    $$("html").removeClass("ios-translucent-bars ios-translucent-modals-");
    setTimeout(function () {
        $$("html").addClass("ios-translucent-bars ios-translucent-modals-");
    }, 500);
}

$$('#signup-screen').on('loginscreen:open', function () {
    console.log("popup:open");
    window.signupImage = null;
    var calendarDefault = app.calendar.create({
        inputEl: '#birthdate-calendar',
        dateFormat: "yyyy-mm-dd",
        closeOnSelect: true,
        backdrop: true,
    });

    if (!window.intlTelInputGlobals.getInstance(document.getElementById("register-phone-number"))) {
        intlTelInput(document.getElementById("register-phone-number"), {
            allowDropdown: true,
            autoHideDialCode: true,
            autoPlaceholder: 'polite',//aggressive
            customContainer: '',
            customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                return "e.g. " + selectedCountryPlaceholder;
            },
            dropdownContainer: null,
            excludeCountries: ['is'],
            formatOnDisplay: true,
            hiddenInput: "",
            initialCountry: window.country == "ot" ? "lb" : window.country,//"lb",
            // geoIpLookup: function (success, failure) {
            //     app.request.get("http://ip-api.com/json/", {}, function (resp) {
            //         var countryCode = (resp && resp.countryCode) ? resp.countryCode : "";
            //         success(countryCode);
            //     }, function (error) {
            //         console.log(error);
            //     }, "json");
            // },
            localizedCountries: {},
            nationalMode: true,
            //onlyCountries: ['lb'],
            placeholderNumberType: "MOBILE",
            preferredCountries: ["lb"],
            separateDialCode: true,
            //utilsScript: "../../node_modules/intl-tel-input/build/js/utils"
        });
    }

    if (window.deeplinkCode) {
        checkSignUpCode(window.deeplinkCode);
        // $$("#location-code").val(window.deeplinkCode);
        // $$("#location-code-display").val("✓ QR Scanned").addClass("text-color-primary");
    }
});


$$(document).on("click", "#getintouch-job-category-input", function () {
    console.log("click")
    app.smartSelect.open("#getintouch-job-category-dropdown .smart-select")
});
$$(document).on("click", "#getintouch-job-title-input", function () {
    console.log("click")
    app.smartSelect.open("#getintouch-job-title-dropdown .smart-select")
});
$$(document).on("change", "#getintouch-job-category-select", function () {
    var val = $$(this).val();
    if (val == "-99") {
        // $$("#job-category-other").removeClass("display-none");
        $$("#getintouch-job-category-input").val("");
        $$("#getintouch-job-category-input").focus();
    } else {
        // $$("#job-category-other").addClass("display-none");
        $$("#getintouch-job-category-input").val(val);
    }
    $$("#getintouch-job-category-input").trigger("change");
})
$$(document).on("change", "#getintouch-job-title-select", function () {
    var val = $$(this).val();
    if (val == "-99") {
        //$$("#job-title-other").removeClass("display-none");
        $$("#getintouch-job-title-input").val("")
        $$("#getintouch-job-title-input").focus();
    } else {
        //$$("#job-title-other").addClass("display-none");
        $$("#getintouch-job-title-input").val(val);
    }
    $$("#getintouch-job-title-input").trigger("change");
});
app.smartSelect.create({
    el: "#getintouch-job-category-dropdown .smart-select",
    openIn: "popup",
    searchbar: false,
    closeOnSelect: true,
    searchbarPlaceholder: "Search"
});
app.smartSelect.create({
    el: "#getintouch-job-title-dropdown .smart-select",
    openIn: "popup",
    searchbar: false,
    closeOnSelect: true,
    searchbarPlaceholder: "Search"
});
$$('#get-in-touch-screen').on('loginscreen:open', function () {
    if (!window.intlTelInputGlobals.getInstance(document.getElementById("getintouch-phone-number"))) {
        intlTelInput(document.getElementById("getintouch-phone-number"), {
            allowDropdown: true,
            autoHideDialCode: true,
            autoPlaceholder: 'polite',//aggressive
            customContainer: '',
            customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                return "e.g. " + selectedCountryPlaceholder;
            },
            dropdownContainer: null,
            excludeCountries: ['is'],
            formatOnDisplay: true,
            hiddenInput: "",
            initialCountry: window.country == "ot" ? "lb" : window.country,//"lb",
            // geoIpLookup: function (success, failure) {
            //     app.request.get("http://ip-api.com/json/", {}, function (resp) {
            //         var countryCode = (resp && resp.countryCode) ? resp.countryCode : "";
            //         success(countryCode);
            //     }, function (error) {
            //         console.log(error);
            //     }, "json");
            // },
            localizedCountries: {},
            nationalMode: true,
            //onlyCountries: ['lb'],
            placeholderNumberType: "MOBILE",
            preferredCountries: ["lb"],
            separateDialCode: true,
            //utilsScript: "../../node_modules/intl-tel-input/build/js/utils"
        });
    }
});
$$('#get-in-touch-screen .submit-get-in-touch').on('click', function () {
    var getInTouchData = app.form.convertToData("#get-in-touch-screen");
    var iti = window.intlTelInputGlobals.getInstance(document.getElementById("getintouch-phone-number"));
    if (iti.isValidNumber()) {
        getInTouchData['phone'] = iti.getNumber();
    } else {
        app.dialog.alert('Please enter a valid phone number');
        return;
    }
    getInTouchData['device_id'] = window.device_id;


    console.warn(iti);
    var currentCountry = "lb";
    var cntr = window.getCountry();
    if (window.countries[cntr.toLowerCase()]) {
        currentCountry = cntr.toLowerCase();
    }

    var phoneCntr = iti.getSelectedCountryData().iso2;
    if (window.countries[phoneCntr.toLowerCase()]) {
        currentCountry = phoneCntr.toLowerCase();
    }

    app.request({
        headers: {
            "x-api-country": currentCountry
        },
        url: Url.to("guest/get-in-touch"),
        method: "POST",
        data: getInTouchData,
        success: function (data, status, xhr) {
            app.loginScreen.close("#get-in-touch-screen", true);
            app.dialog.alert('Your request has been sent successfully.');
            $$('#get-in-touch-screen input').val("").trigger("change");
            $$('#get-in-touch-screen textarea').val("").trigger("change");
        },
    });

});

$$(".scan-location-code").on("click", function () {
    scanCode();
})

function scanCode() {
    if (window.cordova) {
        cordova.plugins.barcodeScanner.scan(
            function (result) {
                console.log("We got a barcode\n" +
                    "Result: " + result.text + "\n" +
                    "Format: " + result.format + "\n" +
                    "Cancelled: " + result.cancelled);
                var scannedLink = result.text;
                if (scannedLink) {
                    var url = new URL(scannedLink);
                    window.deeplinkCode = url.searchParams.get("join");
                    console.log("CODE", window.deeplinkCode);
                    checkSignUpCode(window.deeplinkCode);
                    // $$("#location-code").val(window.deeplinkCode);
                    // $$("#location-code-display").val("✓ QR Scanned").addClass("text-color-primary");
                } else {
                    app.dialog.alert('Invalid barcode scanned, make sure to scan QR code found on the invitation card.');
                }
            },
            function (error) {
                console.log("Scanning failed: " + error);
            },
            {
                preferFrontCamera: false, // iOS and Android
                showFlipCameraButton: false, // iOS and Android
                showTorchButton: true, // iOS and Android
                torchOn: false, // Android, launch with the torch switched on (if available)
                saveHistory: true, // Android, save scan history (default false)
                prompt: "Place a barcode inside the scan area", // Android
                resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                //formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                //orientation: "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
                //disableAnimations: true, // iOS
                //disableSuccessBeep: false // iOS and Android
            }
        );
    } else {
        // var scannedLink = "https://bit.ly/3886Ccp?join=r5cMIkggvk";
        // var url = new URL(scannedLink);
        // window.deeplinkCode = url.searchParams.get("join");
        window.deeplinkCode = prompt("code");
        checkSignUpCode(window.deeplinkCode);
        //send request, verify qr and country, show signup form
        //$$("#location-code-wrapper").addClass("display-none");
    }
}

function checkSignUpCode(location_code) {
    app.request({
        url: Url.to("auth/check-qr-code"),
        method: "POST",
        preloader: true,
        indicator: false,
        progress: false,
        data: {
            location_code: location_code
        },
        success: function (data, status, xhr) {
            $$(".sign-up-scan").addClass("display-none");
            $$(".sign-up-form").removeClass("display-none");

            $$("#location-code").val(window.deeplinkCode);
            $$("#location-code-display").val("✓ " + data['location']).addClass("text-color-primary");

            selectCountry(data['country']);

            app.dialog.alert("The barcode you scanned corresponds to the below location:<br/><br/>" +
                data['location'] + "<br/><br/>" +
                "To proceed with your sign up, please fill out the provided form. This will enable us to create your account and provide you with access to the Mitsulift platform."
            );
        },
    });
}

function loginToCountry(country_code, data) {
    selectCountry(country_code);
    app.loginScreen.close('#my-login-screen');
    User.logIn(data);
    app.methods.initializeViews();
    app.views.main.router.navigate('/news/', {reloadCurrent: true});
    window.setupRequest();
    app.methods.updateRegid(window.registrationId);
    app.methods.pingServer();
}

function selectCountry(country_code) {
    window.country = country_code;
    //$$(".open-countries-popup .iti__flag").attr('class', 'iti__flag iti__' + window.country);
    localStorage.setItem("country", window.country);
    window.setupRequest();
    let registerCountryInput = window.intlTelInputGlobals.getInstance(document.getElementById("register-phone-number"));
    if (registerCountryInput) {
        if (window.country == "ot") {
            registerCountryInput.setCountry("lb");
            registerCountryInput.setNumber("");
        } else {
            registerCountryInput.setCountry(window.country);
            registerCountryInput.setNumber("");
        }
    }
}

window.switchToCountry = function (country_code) {
    console.log("SWITCHING COUNTRY", country_code)
    window.country = country_code;
    localStorage.setItem("country", window.country);
    window.setupRequest();
    $$(".my-countries-select .iti__flag").attr('class', 'icon f7-icons iti__flag iti__' + window.country);
    app.ptr.refresh('.home-ptr-content');
    app.ptr.refresh('.notifications-ptr-content');
    app.ptr.refresh('.news-ptr-content');
}

window.reloadIdentity = function (preloader, callback) {
    app.request({
        url: Url.to("user/identity"),
        method: "GET",
        preloader: !!preloader,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
            User.logIn(data);
            if (Object.keys(data['countries']).indexOf(window.country) < 0) {
                //country does not exist
                window.country = Object.keys(data['countries'])[0];
                localStorage.setItem("country", window.country);
                window.setupRequest();
                $$(".my-countries-select .iti__flag").attr('class', 'icon f7-icons iti__flag iti__' + window.country);
                app.ptr.refresh('.home-ptr-content');
                app.ptr.refresh('.notifications-ptr-content');
                app.ptr.refresh('.news-ptr-content');
            }
            if (callback) {
                callback(data);
            }
            if (data['password_expired']) {
                app.views.current.router.navigate("/change-password/", {
                    context: {
                        preventBack: true,
                        extraMessage: "<span class='text-color-primary'>Your password has expired, please set a new password to continue using the app.</span>",
                    }
                });
            }
        },
    })
}
if (window.loggedIn) {
    window.reloadIdentity();
}

$$(document).on("click", ".password-view-button", function () {
    if ($$(this).hasClass("active")) {
        $$(this).parent().find("input.was-password").attr('type', 'password');
    } else {
        $$(this).parent().find("input[type='password']").addClass("was-password").attr('type', 'text');
    }
    $$(this).toggleClass("active")
})

$$(document).on("click", "#job-category-input", function () {
    console.log("click")
    app.smartSelect.open("#job-category-dropdown .smart-select")
});
$$(document).on("click", "#job-title-input", function () {
    console.log("click")
    app.smartSelect.open("#job-title-dropdown .smart-select")
});
$$(document).on("change", "#job-category-select", function () {
    var val = $$(this).val();
    if (val == "-99") {
        // $$("#job-category-other").removeClass("display-none");
        $$("#job-category-input").val("");
        $$("#job-category-input").focus();
    } else {
        // $$("#job-category-other").addClass("display-none");
        $$("#job-category-input").val(val);
    }
    $$("#job-category-input").trigger("change");
})
$$(document).on("change", "#job-title-select", function () {
    var val = $$(this).val();
    if (val == "-99") {
        //$$("#job-title-other").removeClass("display-none");
        $$("#job-title-input").val("")
        $$("#job-title-input").focus();
    } else {
        //$$("#job-title-other").addClass("display-none");
        $$("#job-title-input").val(val);
    }
    $$("#job-title-input").trigger("change");
});
app.smartSelect.create({
    el: "#job-category-dropdown .smart-select",
    openIn: "popup",
    searchbar: false,
    closeOnSelect: true,
    searchbarPlaceholder: "Search"
});
app.smartSelect.create({
    el: "#job-title-dropdown .smart-select",
    openIn: "popup",
    searchbar: false,
    closeOnSelect: true,
    searchbarPlaceholder: "Search"
});

$$(document).on("click", "#signup-accept-tnc", function (e) {
    $$(".submit-sign-up").addClass("disabled");
    if ($$("#signup-accept-tnc").is(":checked")) {
        $$(".submit-sign-up").removeClass("disabled");
    }
});
$$(document).on("click", "#tnc-block a", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (window.cordova) {
        window.cordova.InAppBrowser.open($$(e.target).attr("href"), '_system');
    } else {
        window.open($$(e.target).attr("href"), "_system");
    }
});

$$(document).on("click", ".select-country", function (e) {
    if ($$(e.target).hasClass("select-country")) {
        window.country = $$(e.target).data("country");
    } else {
        window.country = $$(e.target).parents(".select-country").data("country");
    }
    selectCountry(window.country);
});

$$(document).on("click", ".open-countries-popup", function (e) {
    var listHtml = "";
    Object.keys(window.countries).forEach((country_code) => {
        listHtml += `<li>
          <a href="#" class="item-link item-content select-country" data-country="${country_code}" data-name="${window.countries[country_code]}">
            <div class="item-media"><i class="iti__flag iti__${country_code}"></i></div>
            <div class="item-inner">
              <div class="item-title">${window.countries[country_code]}</div>
            </div>
          </a>
        </li>`;
    });
    var countryPopup = app.popover.create({
        targetEl: e.target,//".open-countries-popup",
        content: '<div class="popover">' +
            '<div class="popover-inner">' +
            `<div class="list">
                  <ul>
                    ${listHtml}
                </ul>
            </div>` +
            '</div>' +
            '</div>',
    });
    countryPopup.open();
});
$$(document).on("click", ".open-my-countries-popup", function (e) {
    var listHtml = "";
    Object.keys(window.identity['countries']).forEach((country_code) => {
        listHtml += `<li>
          <a href="#" class="item-link item-content select-my-country" data-country="${country_code}" data-name="${window.identity['countries'][country_code]}">
            <div class="item-media"><i class="iti__flag iti__${country_code}"></i></div>
            <div class="item-inner">
              <div class="item-title">${window.identity['countries'][country_code]}</div>
            </div>
          </a>
        </li>`;
    });
    var countryPopup = app.popover.create({
        targetEl: e.target,//".open-countries-popup",
        content: '<div class="popover">' +
            '<div class="popover-inner">' +
            `<div class="list">
                  <ul>
                    ${listHtml}
                </ul>
            </div>` +
            '</div>' +
            '</div>',
    });
    countryPopup.open();
});
$$(document).on("click", ".select-my-country", function (e) {
    if ($$(e.target).hasClass("select-my-country")) {
        window.country = $$(e.target).data("country");
    } else {
        window.country = $$(e.target).parents(".select-my-country").data("country");
    }
    localStorage.setItem("country", window.country);
    window.location.reload();
});

$$(".open-countries-popup .iti__flag").attr('class', 'iti__flag iti__' + window.country);

$$(document).on("click", ".did-not-receive-code", function (e) {
    var listHtml = "";
    var didNotReceivePopover = app.popover.create({
        targetEl: e.target,//".open-countries-popup",
        content: '<div class="popover">' +
            '<div class="popover-inner">' +
            `<div class="block">
                Invitation cards are usually placed inside elevators, 
                so check there to find yours.
                <br/>
                But if you still can't find it, don't worry! Just contact the Mitsulift support team for help. 
            </div>` +
            '</div>' +
            '</div>',
    });
    didNotReceivePopover.open();
});

app.request({
    url: Url.to("data/contact-info"),
    method: "GET",
    preloader: false,
    indicator: false,
    progress: false,
    success: function (data, status, xhr) {
        console.log(">>CONTACT>>", data)
        app.data.phone = data.phone;
        app.data.email = data.email;
    },
});

window.testBack = () => {
    const event = new Event('backbutton');
    document.dispatchEvent(event)
}
window.average = function (values) {
    var avg = values.reduce((a, b) => parseFloat(a) + parseFloat(b), 0) / values.length;
    console.log(">>", values, avg);
    return avg;
}

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const openPage = urlParams.get('open')
if (openPage) {
    if (openPage === "notifications") {
        if (window.loggedIn) {
            setTimeout(() => {
                app.tab.show(".view-notifications", ".tab-link[href='#view-notifications']", false);
            }, 500);
        }
    }
}

//document.addEventListener('contextmenu', event => event.preventDefault());
//$$("#app")[0].addEventListener('contextmenu', event => event.preventDefault());
// (function(){
//     debugger
// }())
window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
window.alertIfMobile = ()=>{
    if(window.mobileCheck()){
        //alert("MOBILE");
        var popup = app.popup.create({
            content: /*html*/`
                    <div class="popup chart-popup login-screen custom-login-screen">
                      <div class="view">
                      <div class="page">
                        <div class="page-content login-screen-content" style="overflow: hidden; background: linear-gradient(236deg, black 0%, #123461 100%)">
                            <div></div>
                            <div class="padding-vertical" style="width: 300px; position: relative;margin: 0 auto">
                            <div class="app-icon-wrapper elevation-5">
                                <div class="app-icon"></div>
                            </div>
                            </div>
                            <div class="block margin-bottom">
                                <div class="block-title-large text-align-center text-color-white" style="font-size: 55px;">Download</div>
                                <div class="block-title-medium text-align-center text-color-white" style="font-size: 28px;">Our Mobile App!</div>
                                <div class="display-flex align-items-center justify-content-center margin-top">
                                    <a href="https://app.mitsulift.com" target="_blank"
                                    class="button button-fill button-large bg-color-white text-color-black button-rounded external" style="width: 280px">Download</a>
                                </div>
                                <div class="text-align-center text-color-white">
                                <span style="font-size: 11px;width: 280px;display: inline-block">
                                *This portal is not supported on mobile devices, please download our app for the best experience
                                </span>
                                </div>
                            </div> 
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                      </div>
                      </div>
                    </div>
                  `,
            on: {
                closed: function () {
                    window.alertIfMobile();
                }
            }
        });
        popup.open();
    }
}
window.alertIfMobile();

